const BlockHeader = (props) => {
  const { title, subText } = props;

  return (
    <div className="mb-3">
      <h2>{title}</h2>
      {subText !== "" ? (
        <span class="text-regular d-block text-secondary">{subText}</span>
      ) : null}
    </div>
  );
};

export default BlockHeader;
